module.exports = __webpack_public_path__ + "img/portrait.63ae6f0e.png";